export { default } from "./src/mobile-app";

export type { UniformMobileAppProps } from "./src/mobile-app";
